import React, { useEffect, useRef } from "react";
import { mapManager } from "../../globals";

export const MapElement: React.FC = () => {
  const mapContainer = useRef(null);

  useEffect(() => {
    if (!mapContainer.current) {
      return;
    }
    mapManager.init(mapContainer.current);
  }, [mapContainer.current]);

  return (
    <div
      style={{
        zIndex: 0,
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100vh",
      }}
      ref={mapContainer}
      className="map"
      id="map"
    />
  );
};
